type Input = {
    playbackId: string;
};

export const buildMuxUrl = ({ playbackId }: Input): string => {
    const url = new URL(`https://stream.mux.com/${playbackId}.m3u8`);

    return url.toString();
};
